'use strict';

exports.__esModule = true;
var DEFAULT_WARNING_MESSAGE = exports.DEFAULT_WARNING_MESSAGE = 'Oops! Something went wrong!';
var DEFAULT_ERROR_MESSAGE = exports.DEFAULT_ERROR_MESSAGE = 'Oops! Something went wrong!';
var DEFAULT_INVARIANT_MESSAGE = exports.DEFAULT_INVARIANT_MESSAGE = 'Invariant condition not met!';